import {
  COIN_SELECTOR_MOBILE_PRESET_LOGGED_MAIN,
  COIN_SELECTOR_MOBILE_PRESET_NARROW,
  ICoinSelectorMobilePreset,
} from "./mobile-presets";

export interface ICoinSelectorLayoutProps {
  forceMobileSingleLine: boolean;
  mobilePreset: ICoinSelectorMobilePreset;
}

export const COIN_SELECTOR_LAYOUT_PROPS_STANDARD: ICoinSelectorLayoutProps = {
  forceMobileSingleLine: true,
  mobilePreset: COIN_SELECTOR_MOBILE_PRESET_LOGGED_MAIN,
};

const NARROW_COLLAPSIBLE_SELECTOR_BREAKPOINT_PX = 349;

export const provideCoinSelectorLayoutPropsForCollapsibleSurface = (
  width: number
): ICoinSelectorLayoutProps => ({
  forceMobileSingleLine: true,
  mobilePreset:
    width < NARROW_COLLAPSIBLE_SELECTOR_BREAKPOINT_PX
      ? COIN_SELECTOR_MOBILE_PRESET_NARROW
      : COIN_SELECTOR_MOBILE_PRESET_LOGGED_MAIN,
});
